/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/orlando-instructions/orlando-modal-new-delivery-point.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../../public/upgrade/root/toast/notification.service';
import * as import10 from '../../../../../../../public/upgrade/root/ga/ga.service';
import * as import11 from '../../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import12 from '../../../../../../node_modules/angular2-text-mask/dist/angular2TextMask.ngfactory';
import * as import13 from '@ngx-translate/core/src/translate.pipe';
import * as import14 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import15 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import16 from '@angular/core/src/linker/element_ref';
import * as import17 from '@ngx-translate/core/src/translate.service';
import * as import18 from '@angular/common/src/directives/ng_class';
import * as import19 from 'angular2-text-mask/dist/angular2TextMask';
import * as import20 from '@angular/forms/src/directives/control_value_accessor';
export class Wrapper_OrlandoModalNewDeliveryPointComponent {
  /*private*/ _eventHandler:Function;
  context:import0.OrlandoModalNewDeliveryPointComponent;
  /*private*/ _changed:boolean;
  /*private*/ _changes:{[key: string]:any};
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  subscription0:any;
  subscription1:any;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this._changes = {};
    this.context = new import0.OrlandoModalNewDeliveryPointComponent(p0,p1);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
    (this.subscription1 && this.subscription1.unsubscribe());
  }
  check_errors(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.errors = currValue;
      this._changes['errors'] = new import1.SimpleChange(this._expr_0,currValue);
      this._expr_0 = currValue;
    }
  }
  check_dto(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.dto = currValue;
      this._changes['dto'] = new import1.SimpleChange(this._expr_1,currValue);
      this._expr_1 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) {
      if (changed) {
        this.context.ngOnChanges(this._changes);
        this._changes = {};
      }
      if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); }
    }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean,emit1:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.closeModal.subscribe(_eventHandler.bind(view,'closeModal'))); }
    if (emit1) { (this.subscription1 = this.context.meetingPointAdded.subscribe(_eventHandler.bind(view,'meetingPointAdded'))); }
  }
}
var renderType_OrlandoModalNewDeliveryPointComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_OrlandoModalNewDeliveryPointComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.OrlandoModalNewDeliveryPointComponent>;
  _OrlandoModalNewDeliveryPointComponent_0_3:Wrapper_OrlandoModalNewDeliveryPointComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_OrlandoModalNewDeliveryPointComponent_Host0,renderType_OrlandoModalNewDeliveryPointComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'orlando-modal-new-delivery-point',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_OrlandoModalNewDeliveryPointComponent0(this.viewUtils,this,0,this._el_0);
    this._OrlandoModalNewDeliveryPointComponent_0_3 = new Wrapper_OrlandoModalNewDeliveryPointComponent(this.injectorGet(import9.NotificationService,this.parentIndex),this.injectorGet(import10.GAService,this.parentIndex));
    this.compView_0.create(this._OrlandoModalNewDeliveryPointComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._OrlandoModalNewDeliveryPointComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.OrlandoModalNewDeliveryPointComponent) && (0 === requestNodeIndex))) { return this._OrlandoModalNewDeliveryPointComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._OrlandoModalNewDeliveryPointComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._OrlandoModalNewDeliveryPointComponent_0_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._OrlandoModalNewDeliveryPointComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const OrlandoModalNewDeliveryPointComponentNgFactory:import8.ComponentFactory<import0.OrlandoModalNewDeliveryPointComponent> = new import8.ComponentFactory<import0.OrlandoModalNewDeliveryPointComponent>('orlando-modal-new-delivery-point',View_OrlandoModalNewDeliveryPointComponent_Host0,import0.OrlandoModalNewDeliveryPointComponent);
const styles_OrlandoModalNewDeliveryPointComponent:any[] = ([] as any[]);
var renderType_OrlandoModalNewDeliveryPointComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_OrlandoModalNewDeliveryPointComponent,{});
export class View_OrlandoModalNewDeliveryPointComponent0 extends import2.AppView<import0.OrlandoModalNewDeliveryPointComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _NgClass_26_3:import11.Wrapper_NgClass;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _text_34:any;
  _el_35:any;
  _text_36:any;
  _el_37:any;
  _el_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _text_44:any;
  _text_45:any;
  _text_46:any;
  _text_47:any;
  _el_48:any;
  _text_49:any;
  _el_50:any;
  _el_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _el_55:any;
  _text_56:any;
  _text_57:any;
  _text_58:any;
  _text_59:any;
  _text_60:any;
  _el_61:any;
  _text_62:any;
  _text_63:any;
  _el_64:any;
  _text_65:any;
  _el_66:any;
  _text_67:any;
  _el_68:any;
  _text_69:any;
  _text_70:any;
  _text_71:any;
  _text_72:any;
  _text_73:any;
  _text_74:any;
  _text_75:any;
  _el_76:any;
  _text_77:any;
  _el_78:any;
  _text_79:any;
  _el_80:any;
  _text_81:any;
  _el_82:any;
  _text_83:any;
  _el_84:any;
  _text_85:any;
  _el_86:any;
  _text_87:any;
  _el_88:any;
  _text_89:any;
  _text_90:any;
  _el_91:any;
  _text_92:any;
  _el_93:any;
  _text_94:any;
  _text_95:any;
  _text_96:any;
  _text_97:any;
  _el_98:any;
  _text_99:any;
  _el_100:any;
  _text_101:any;
  _el_102:any;
  _MaskedInputDirective_102_3:import12.Wrapper_MaskedInputDirective;
  __NG_VALUE_ACCESSOR_102_4:any[];
  _text_103:any;
  _text_104:any;
  _text_105:any;
  _text_106:any;
  _el_107:any;
  _text_108:any;
  _el_109:any;
  _text_110:any;
  _el_111:any;
  _text_112:any;
  _el_113:any;
  _text_114:any;
  _el_115:any;
  _text_116:any;
  _text_117:any;
  _el_118:any;
  _text_119:any;
  _el_120:any;
  _text_121:any;
  _text_122:any;
  _text_123:any;
  _text_124:any;
  _el_125:any;
  _text_126:any;
  _el_127:any;
  _text_128:any;
  _el_129:any;
  _MaskedInputDirective_129_3:import12.Wrapper_MaskedInputDirective;
  __NG_VALUE_ACCESSOR_129_4:any[];
  _text_130:any;
  _text_131:any;
  _text_132:any;
  _el_133:any;
  _text_134:any;
  _text_135:any;
  _el_136:any;
  _text_137:any;
  _el_138:any;
  _text_139:any;
  _el_140:any;
  _MaskedInputDirective_140_3:import12.Wrapper_MaskedInputDirective;
  __NG_VALUE_ACCESSOR_140_4:any[];
  _text_141:any;
  _text_142:any;
  _text_143:any;
  _text_144:any;
  _text_145:any;
  _el_146:any;
  _text_147:any;
  _el_148:any;
  _text_149:any;
  _el_150:any;
  _text_151:any;
  _text_152:any;
  _text_153:any;
  _text_154:any;
  _text_155:any;
  _el_156:any;
  _text_157:any;
  _el_158:any;
  _text_159:any;
  _el_160:any;
  _text_161:any;
  _el_162:any;
  _text_163:any;
  _text_164:any;
  _text_165:any;
  _text_166:any;
  _el_167:any;
  _text_168:any;
  _el_169:any;
  _text_170:any;
  _text_171:any;
  _text_172:any;
  _text_173:any;
  _text_174:any;
  _text_175:any;
  /*private*/ _expr_183:any;
  _pipe_translate_0:import13.TranslatePipe;
  /*private*/ _expr_185:any;
  _pipe_translate_1:import13.TranslatePipe;
  /*private*/ _expr_187:any;
  _pipe_translate_2:import13.TranslatePipe;
  /*private*/ _expr_189:any;
  _pipe_translate_3:import13.TranslatePipe;
  /*private*/ _expr_191:any;
  _pipe_translate_4:import13.TranslatePipe;
  /*private*/ _expr_193:any;
  _pipe_translate_5:import13.TranslatePipe;
  /*private*/ _expr_195:any;
  _pipe_translate_6:import13.TranslatePipe;
  /*private*/ _expr_197:any;
  /*private*/ _expr_198:any;
  /*private*/ _expr_199:any;
  _pipe_translate_7:import13.TranslatePipe;
  _map_201:any;
  /*private*/ _expr_202:any;
  _pipe_translate_8:import13.TranslatePipe;
  _map_204:any;
  /*private*/ _expr_205:any;
  _pipe_translate_9:import13.TranslatePipe;
  _map_207:any;
  /*private*/ _expr_208:any;
  /*private*/ _expr_209:any;
  /*private*/ _expr_210:any;
  _pipe_translate_10:import13.TranslatePipe;
  /*private*/ _expr_212:any;
  /*private*/ _expr_213:any;
  _pipe_translate_11:import13.TranslatePipe;
  /*private*/ _expr_215:any;
  _pipe_translate_12:import13.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_OrlandoModalNewDeliveryPointComponent0,renderType_OrlandoModalNewDeliveryPointComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_183 = import1.UNINITIALIZED;
    this._expr_185 = import1.UNINITIALIZED;
    this._expr_187 = import1.UNINITIALIZED;
    this._expr_189 = import1.UNINITIALIZED;
    this._expr_191 = import1.UNINITIALIZED;
    this._expr_193 = import1.UNINITIALIZED;
    this._expr_195 = import1.UNINITIALIZED;
    this._expr_197 = import1.UNINITIALIZED;
    this._expr_198 = import1.UNINITIALIZED;
    this._expr_199 = import1.UNINITIALIZED;
    this._map_201 = import3.pureProxy3((p0:any,p1:any,p2:any):{[key: string]:any} => {
      return {
        mask: p0,
        keepCharPositions: p1,
        guide: p2
      }
      ;
    });
    this._expr_202 = import1.UNINITIALIZED;
    this._map_204 = import3.pureProxy3((p0:any,p1:any,p2:any):{[key: string]:any} => {
      return {
        mask: p0,
        keepCharPositions: p1,
        guide: p2
      }
      ;
    });
    this._expr_205 = import1.UNINITIALIZED;
    this._map_207 = import3.pureProxy3((p0:any,p1:any,p2:any):{[key: string]:any} => {
      return {
        mask: p0,
        keepCharPositions: p1,
        guide: p2
      }
      ;
    });
    this._expr_208 = import1.UNINITIALIZED;
    this._expr_209 = import1.UNINITIALIZED;
    this._expr_210 = import1.UNINITIALIZED;
    this._expr_212 = import1.UNINITIALIZED;
    this._expr_213 = import1.UNINITIALIZED;
    this._expr_215 = import1.UNINITIALIZED;
  }
  get _NG_VALUE_ACCESSOR_102_4():any[] {
    if ((this.__NG_VALUE_ACCESSOR_102_4 == null)) { (this.__NG_VALUE_ACCESSOR_102_4 = [this._MaskedInputDirective_102_3.context]); }
    return this.__NG_VALUE_ACCESSOR_102_4;
  }
  get _NG_VALUE_ACCESSOR_129_4():any[] {
    if ((this.__NG_VALUE_ACCESSOR_129_4 == null)) { (this.__NG_VALUE_ACCESSOR_129_4 = [this._MaskedInputDirective_129_3.context]); }
    return this.__NG_VALUE_ACCESSOR_129_4;
  }
  get _NG_VALUE_ACCESSOR_140_4():any[] {
    if ((this.__NG_VALUE_ACCESSOR_140_4 == null)) { (this.__NG_VALUE_ACCESSOR_140_4 = [this._MaskedInputDirective_140_3.context]); }
    return this.__NG_VALUE_ACCESSOR_140_4;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray4(4,'class','eva-3-modal eva-3-modal--coachmark -sm -show-modal','id','modalNewDeliveryPoint'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','modal-content modal-orlando-new-delivery-point'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','modal-coachmark-title container-header-modal'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','container-title-modal'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h5',new import3.InlineArray2(2,'class','eva-3-h4 left h4-modal-new-feature font-bold'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_6,'i',new import3.InlineArray4(4,'class','modal-close eva-3-icon-close icon-close-modal-new','id','iconCloseModal'),(null as any));
    this._text_12 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_13 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_4,'h6',new import3.InlineArray2(2,'class','sara-reva-eva-3-overline-1 subtitle-modal'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_17 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','modal-coachmark-description center container-modal-orlando'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n            ',(null as any));
    this._text_20 = this.renderer.createText(this._el_18,'\n            ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_18,'div',new import3.InlineArray2(2,'class','dropoff-point-radio-container inline-block container-selector-nps'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n                ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'h6',new import3.InlineArray2(2,'class','sara-reva-eva-3-overline-1 title-selector-nps'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'',(null as any));
    this._text_25 = this.renderer.createText(this._el_21,'\n                ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_21,'div',new import3.InlineArray2(2,'class','eva-3-nps '),(null as any));
    this._NgClass_26_3 = new import11.Wrapper_NgClass(this.parentView.injectorGet(import14.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import15.KeyValueDiffers,this.parentIndex),new import16.ElementRef(this._el_26),this.renderer);
    this._text_27 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_26,'div',new import3.InlineArray2(2,'class','nps-container'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n                        ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_28,'ul',new import3.InlineArray2(2,'class','nps-options container-nps-options'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n                            ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_30,'li',new import3.InlineArray2(2,'class','nps-option -eva-3-hide-large -eva-3-hide-medium'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'N/A',(null as any));
    this._text_34 = this.renderer.createText(this._el_30,'\n                            ',(null as any));
    this._el_35 = import3.createRenderElement(this.renderer,this._el_30,'li',new import3.InlineArray2(2,'class','-top -center -sm nps-option eva-3-tooltip font-bold'),(null as any));
    this._text_36 = this.renderer.createText(this._el_35,'',(null as any));
    this._el_37 = import3.createRenderElement(this.renderer,this._el_35,'span',new import3.InlineArray2(2,'class','nps-tooltip-container tooltip-container'),(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_37,'i',new import3.InlineArray2(2,'class','tooltip-marker'),(null as any));
    this._text_39 = this.renderer.createText(this._el_37,'\n                                    ',(null as any));
    this._el_40 = import3.createRenderElement(this.renderer,this._el_37,'span',new import3.InlineArray2(2,'class','tooltip-content'),(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'\n                                        ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_40,'p',new import3.InlineArray2(2,'class','tooltip-text'),(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'',(null as any));
    this._text_44 = this.renderer.createText(this._el_40,'\n                                    ',(null as any));
    this._text_45 = this.renderer.createText(this._el_37,'\n                                ',(null as any));
    this._text_46 = this.renderer.createText(this._el_35,'\n                            ',(null as any));
    this._text_47 = this.renderer.createText(this._el_30,'\n                            ',(null as any));
    this._el_48 = import3.createRenderElement(this.renderer,this._el_30,'li',new import3.InlineArray2(2,'class','-top -center -sm nps-option eva-3-tooltip font-bold'),(null as any));
    this._text_49 = this.renderer.createText(this._el_48,'',(null as any));
    this._el_50 = import3.createRenderElement(this.renderer,this._el_48,'span',new import3.InlineArray2(2,'class','nps-tooltip-container tooltip-container'),(null as any));
    this._el_51 = import3.createRenderElement(this.renderer,this._el_50,'i',new import3.InlineArray2(2,'class','tooltip-marker'),(null as any));
    this._text_52 = this.renderer.createText(this._el_50,'\n                                    ',(null as any));
    this._el_53 = import3.createRenderElement(this.renderer,this._el_50,'span',new import3.InlineArray2(2,'class','tooltip-content'),(null as any));
    this._text_54 = this.renderer.createText(this._el_53,'\n                                        ',(null as any));
    this._el_55 = import3.createRenderElement(this.renderer,this._el_53,'p',new import3.InlineArray2(2,'class','tooltip-text'),(null as any));
    this._text_56 = this.renderer.createText(this._el_55,'',(null as any));
    this._text_57 = this.renderer.createText(this._el_53,'\n                                    ',(null as any));
    this._text_58 = this.renderer.createText(this._el_50,'\n                                ',(null as any));
    this._text_59 = this.renderer.createText(this._el_48,'\n                            ',(null as any));
    this._text_60 = this.renderer.createText(this._el_30,'\n                            ',(null as any));
    this._el_61 = import3.createRenderElement(this.renderer,this._el_30,'li',new import3.InlineArray2(2,'class','nps-option-center'),(null as any));
    this._text_62 = this.renderer.createText(this._el_30,'\n                        ',(null as any));
    this._text_63 = this.renderer.createText(this._el_28,'\n                        ',(null as any));
    this._el_64 = import3.createRenderElement(this.renderer,this._el_28,'div',new import3.InlineArray2(2,'class','nps-input-container'),(null as any));
    this._text_65 = this.renderer.createText(this._el_64,'\n                            ',(null as any));
    this._el_66 = import3.createRenderElement(this.renderer,this._el_64,'div',new import3.InlineArray2(2,'class','nps-input-content'),(null as any));
    this._text_67 = this.renderer.createText(this._el_66,'\n                                ',(null as any));
    this._el_68 = import3.createRenderElement(this.renderer,this._el_66,'input',new import3.InlineArray8(8,'class','nps-input','max','3','min','0','type','range'),(null as any));
    this._text_69 = this.renderer.createText(this._el_66,'\n                            ',(null as any));
    this._text_70 = this.renderer.createText(this._el_64,'\n                        ',(null as any));
    this._text_71 = this.renderer.createText(this._el_28,'\n                    ',(null as any));
    this._text_72 = this.renderer.createText(this._el_26,'\n                ',(null as any));
    this._text_73 = this.renderer.createText(this._el_21,'\n            ',(null as any));
    this._text_74 = this.renderer.createText(this._el_18,'\n\n            ',(null as any));
    this._text_75 = this.renderer.createText(this._el_18,'\n            ',(null as any));
    this._el_76 = import3.createRenderElement(this.renderer,this._el_18,'div',new import3.InlineArray2(2,'class','container-main-single-stop'),(null as any));
    this._text_77 = this.renderer.createText(this._el_76,'\n                ',(null as any));
    this._el_78 = import3.createRenderElement(this.renderer,this._el_76,'div',new import3.InlineArray2(2,'class','container-sec-single-stop'),(null as any));
    this._text_79 = this.renderer.createText(this._el_78,'\n                    ',(null as any));
    this._el_80 = import3.createRenderElement(this.renderer,this._el_78,'div',new import3.InlineArray2(2,'class','inline-block'),(null as any));
    this._text_81 = this.renderer.createText(this._el_80,'\n                        ',(null as any));
    this._el_82 = import3.createRenderElement(this.renderer,this._el_80,'span',new import3.InlineArray2(2,'class','eva-3-radio'),(null as any));
    this._text_83 = this.renderer.createText(this._el_82,'\n                            ',(null as any));
    this._el_84 = import3.createRenderElement(this.renderer,this._el_82,'label',new import3.InlineArray2(2,'class','radio-label-container'),(null as any));
    this._text_85 = this.renderer.createText(this._el_84,'\n                                ',(null as any));
    this._el_86 = import3.createRenderElement(this.renderer,this._el_84,'input',new import3.InlineArray16(10,'class','radio-tag','id','radioSingleStop','name','stopOption','type','radio','value','singleStop'),(null as any));
    this._text_87 = this.renderer.createText(this._el_84,'\n                                ',(null as any));
    this._el_88 = import3.createRenderElement(this.renderer,this._el_84,'i',new import3.InlineArray2(2,'class','radio-circle'),(null as any));
    this._text_89 = this.renderer.createText(this._el_84,'\n                            ',(null as any));
    this._text_90 = this.renderer.createText(this._el_82,'\n                            ',(null as any));
    this._el_91 = import3.createRenderElement(this.renderer,this._el_82,'div',new import3.InlineArray2(2,'class','dropoff-point-radio-message'),(null as any));
    this._text_92 = this.renderer.createText(this._el_91,'\n                                ',(null as any));
    this._el_93 = import3.createRenderElement(this.renderer,this._el_91,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md -eva-3-pb-sm radio-message-label'),(null as any));
    this._text_94 = this.renderer.createText(this._el_93,'',(null as any));
    this._text_95 = this.renderer.createText(this._el_91,'\n                            ',(null as any));
    this._text_96 = this.renderer.createText(this._el_82,'\n                        ',(null as any));
    this._text_97 = this.renderer.createText(this._el_80,'\n                        ',(null as any));
    this._el_98 = import3.createRenderElement(this.renderer,this._el_80,'div',new import3.InlineArray2(2,'class','eva-3-input -md width-input'),(null as any));
    this._text_99 = this.renderer.createText(this._el_98,'\n                            ',(null as any));
    this._el_100 = import3.createRenderElement(this.renderer,this._el_98,'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_101 = this.renderer.createText(this._el_100,'\n                                ',(null as any));
    this._el_102 = import3.createRenderElement(this.renderer,this._el_100,'input',new import3.InlineArray8(8,'class','input-tag','disabled','','id','singleStop','type','text'),(null as any));
    this._MaskedInputDirective_102_3 = new import12.Wrapper_MaskedInputDirective(this.renderer,new import16.ElementRef(this._el_102));
    this._text_103 = this.renderer.createText(this._el_100,'\n                            ',(null as any));
    this._text_104 = this.renderer.createText(this._el_98,'\n                        ',(null as any));
    this._text_105 = this.renderer.createText(this._el_80,'\n                    ',(null as any));
    this._text_106 = this.renderer.createText(this._el_78,'\n                    ',(null as any));
    this._el_107 = import3.createRenderElement(this.renderer,this._el_78,'div',new import3.InlineArray2(2,'class','container-range'),(null as any));
    this._text_108 = this.renderer.createText(this._el_107,'\n                        ',(null as any));
    this._el_109 = import3.createRenderElement(this.renderer,this._el_107,'span',new import3.InlineArray2(2,'class','eva-3-radio display-block'),(null as any));
    this._text_110 = this.renderer.createText(this._el_109,'\n                            ',(null as any));
    this._el_111 = import3.createRenderElement(this.renderer,this._el_109,'label',new import3.InlineArray2(2,'class','radio-label-container'),(null as any));
    this._text_112 = this.renderer.createText(this._el_111,'\n                                ',(null as any));
    this._el_113 = import3.createRenderElement(this.renderer,this._el_111,'input',new import3.InlineArray16(10,'class','radio-tag','id','radioRangeStop','name','stopOption','type','radio','value','rangeStop'),(null as any));
    this._text_114 = this.renderer.createText(this._el_111,'\n                                ',(null as any));
    this._el_115 = import3.createRenderElement(this.renderer,this._el_111,'i',new import3.InlineArray2(2,'class','radio-circle'),(null as any));
    this._text_116 = this.renderer.createText(this._el_111,'\n                            ',(null as any));
    this._text_117 = this.renderer.createText(this._el_109,'\n                            ',(null as any));
    this._el_118 = import3.createRenderElement(this.renderer,this._el_109,'div',new import3.InlineArray2(2,'class','dropoff-point-radio-message'),(null as any));
    this._text_119 = this.renderer.createText(this._el_118,'\n                                ',(null as any));
    this._el_120 = import3.createRenderElement(this.renderer,this._el_118,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md -eva-3-pb-sm radio-message-label'),(null as any));
    this._text_121 = this.renderer.createText(this._el_120,'',(null as any));
    this._text_122 = this.renderer.createText(this._el_118,'\n                            ',(null as any));
    this._text_123 = this.renderer.createText(this._el_109,'\n                        ',(null as any));
    this._text_124 = this.renderer.createText(this._el_107,'\n                        ',(null as any));
    this._el_125 = import3.createRenderElement(this.renderer,this._el_107,'div',new import3.InlineArray2(2,'class','eva-3-input -md inline-block width-input'),(null as any));
    this._text_126 = this.renderer.createText(this._el_125,'\n                            ',(null as any));
    this._el_127 = import3.createRenderElement(this.renderer,this._el_125,'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_128 = this.renderer.createText(this._el_127,'\n                                ',(null as any));
    this._el_129 = import3.createRenderElement(this.renderer,this._el_127,'input',new import3.InlineArray8(8,'class','input-tag','disabled','','id','rangeStopFrom','type','text'),(null as any));
    this._MaskedInputDirective_129_3 = new import12.Wrapper_MaskedInputDirective(this.renderer,new import16.ElementRef(this._el_129));
    this._text_130 = this.renderer.createText(this._el_127,'\n                            ',(null as any));
    this._text_131 = this.renderer.createText(this._el_125,'\n                        ',(null as any));
    this._text_132 = this.renderer.createText(this._el_107,'\n                        ',(null as any));
    this._el_133 = import3.createRenderElement(this.renderer,this._el_107,'h6',new import3.InlineArray2(2,'class','sara-reva-eva-3-overline-1 title-stop-until'),(null as any));
    this._text_134 = this.renderer.createText(this._el_133,'',(null as any));
    this._text_135 = this.renderer.createText(this._el_107,'\n                        ',(null as any));
    this._el_136 = import3.createRenderElement(this.renderer,this._el_107,'div',new import3.InlineArray2(2,'class','eva-3-input -md inline-block width-input'),(null as any));
    this._text_137 = this.renderer.createText(this._el_136,'\n                            ',(null as any));
    this._el_138 = import3.createRenderElement(this.renderer,this._el_136,'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_139 = this.renderer.createText(this._el_138,'\n                                ',(null as any));
    this._el_140 = import3.createRenderElement(this.renderer,this._el_138,'input',new import3.InlineArray8(8,'class','input-tag','disabled','','id','rangeStopTo','type','text'),(null as any));
    this._MaskedInputDirective_140_3 = new import12.Wrapper_MaskedInputDirective(this.renderer,new import16.ElementRef(this._el_140));
    this._text_141 = this.renderer.createText(this._el_138,'\n                            ',(null as any));
    this._text_142 = this.renderer.createText(this._el_136,'\n                        ',(null as any));
    this._text_143 = this.renderer.createText(this._el_107,'\n                    ',(null as any));
    this._text_144 = this.renderer.createText(this._el_78,'\n                ',(null as any));
    this._text_145 = this.renderer.createText(this._el_76,'\n                ',(null as any));
    this._el_146 = import3.createRenderElement(this.renderer,this._el_76,'div',new import3.InlineArray2(2,'class','container-message-error'),(null as any));
    this._text_147 = this.renderer.createText(this._el_146,'\n                    ',(null as any));
    this._el_148 = import3.createRenderElement(this.renderer,this._el_146,'i',new import3.InlineArray2(2,'class','eva-3-icon-error-circle icon-inline align-icon'),(null as any));
    this._text_149 = this.renderer.createText(this._el_146,'\n                    ',(null as any));
    this._el_150 = import3.createRenderElement(this.renderer,this._el_146,'p',new import3.InlineArray2(2,'class','text-message-error'),(null as any));
    this._text_151 = this.renderer.createText(this._el_150,'',(null as any));
    this._text_152 = this.renderer.createText(this._el_146,'\n                ',(null as any));
    this._text_153 = this.renderer.createText(this._el_76,'\n            ',(null as any));
    this._text_154 = this.renderer.createText(this._el_18,'\n        ',(null as any));
    this._text_155 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_156 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','modal-coachmark-actions'),(null as any));
    this._text_157 = this.renderer.createText(this._el_156,'\n            ',(null as any));
    this._el_158 = import3.createRenderElement(this.renderer,this._el_156,'div',new import3.InlineArray2(2,'class','inline-block'),(null as any));
    this._text_159 = this.renderer.createText(this._el_158,'\n                ',(null as any));
    this._el_160 = import3.createRenderElement(this.renderer,this._el_158,'button',new import3.InlineArray4(4,'class','eva-3-btn -md -primary','id','btnSaveNewDeliveryPoint'),(null as any));
    this._text_161 = this.renderer.createText(this._el_160,'\n                    ',(null as any));
    this._el_162 = import3.createRenderElement(this.renderer,this._el_160,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_163 = this.renderer.createText(this._el_162,'',(null as any));
    this._text_164 = this.renderer.createText(this._el_160,'\n                ',(null as any));
    this._text_165 = this.renderer.createText(this._el_158,'\n            ',(null as any));
    this._text_166 = this.renderer.createText(this._el_156,'\n            ',(null as any));
    this._el_167 = import3.createRenderElement(this.renderer,this._el_156,'button',new import3.InlineArray4(4,'class','eva-3-btn -md -link','id','btnCancelSave'),(null as any));
    this._text_168 = this.renderer.createText(this._el_167,'\n                ',(null as any));
    this._el_169 = import3.createRenderElement(this.renderer,this._el_167,'em',new import3.InlineArray2(2,'class','btn-text'),(null as any));
    this._text_170 = this.renderer.createText(this._el_169,'',(null as any));
    this._text_171 = this.renderer.createText(this._el_167,'\n            ',(null as any));
    this._text_172 = this.renderer.createText(this._el_156,'\n        ',(null as any));
    this._text_173 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_174 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_175 = this.renderer.createText(parentRenderNode,'\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n',(null as any));
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_11,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_11));
    this._pipe_translate_1 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_35,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_35));
    this._pipe_translate_3 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_48,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_48));
    this._pipe_translate_5 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_86,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_86));
    this._pipe_translate_7 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_102,new import3.InlineArray8(6,'focusout',(null as any),'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_102));
    var disposable_5:Function = import3.subscribeToRenderElement(this,this._el_113,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_113));
    this._pipe_translate_8 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_6:Function = import3.subscribeToRenderElement(this,this._el_129,new import3.InlineArray8(6,'focusout',(null as any),'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_129));
    this._pipe_translate_9 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_7:Function = import3.subscribeToRenderElement(this,this._el_140,new import3.InlineArray8(6,'focusout',(null as any),'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_140));
    this._pipe_translate_10 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_8:Function = import3.subscribeToRenderElement(this,this._el_158,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_158));
    var disposable_9:Function = import3.subscribeToRenderElement(this,this._el_160,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_160));
    this._pipe_translate_11 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    var disposable_10:Function = import3.subscribeToRenderElement(this,this._el_167,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_167));
    this._pipe_translate_12 = new import13.TranslatePipe(this.parentView.injectorGet(import17.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._text_34,
      this._el_35,
      this._text_36,
      this._el_37,
      this._el_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._text_44,
      this._text_45,
      this._text_46,
      this._text_47,
      this._el_48,
      this._text_49,
      this._el_50,
      this._el_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._text_57,
      this._text_58,
      this._text_59,
      this._text_60,
      this._el_61,
      this._text_62,
      this._text_63,
      this._el_64,
      this._text_65,
      this._el_66,
      this._text_67,
      this._el_68,
      this._text_69,
      this._text_70,
      this._text_71,
      this._text_72,
      this._text_73,
      this._text_74,
      this._text_75,
      this._el_76,
      this._text_77,
      this._el_78,
      this._text_79,
      this._el_80,
      this._text_81,
      this._el_82,
      this._text_83,
      this._el_84,
      this._text_85,
      this._el_86,
      this._text_87,
      this._el_88,
      this._text_89,
      this._text_90,
      this._el_91,
      this._text_92,
      this._el_93,
      this._text_94,
      this._text_95,
      this._text_96,
      this._text_97,
      this._el_98,
      this._text_99,
      this._el_100,
      this._text_101,
      this._el_102,
      this._text_103,
      this._text_104,
      this._text_105,
      this._text_106,
      this._el_107,
      this._text_108,
      this._el_109,
      this._text_110,
      this._el_111,
      this._text_112,
      this._el_113,
      this._text_114,
      this._el_115,
      this._text_116,
      this._text_117,
      this._el_118,
      this._text_119,
      this._el_120,
      this._text_121,
      this._text_122,
      this._text_123,
      this._text_124,
      this._el_125,
      this._text_126,
      this._el_127,
      this._text_128,
      this._el_129,
      this._text_130,
      this._text_131,
      this._text_132,
      this._el_133,
      this._text_134,
      this._text_135,
      this._el_136,
      this._text_137,
      this._el_138,
      this._text_139,
      this._el_140,
      this._text_141,
      this._text_142,
      this._text_143,
      this._text_144,
      this._text_145,
      this._el_146,
      this._text_147,
      this._el_148,
      this._text_149,
      this._el_150,
      this._text_151,
      this._text_152,
      this._text_153,
      this._text_154,
      this._text_155,
      this._el_156,
      this._text_157,
      this._el_158,
      this._text_159,
      this._el_160,
      this._text_161,
      this._el_162,
      this._text_163,
      this._text_164,
      this._text_165,
      this._text_166,
      this._el_167,
      this._text_168,
      this._el_169,
      this._text_170,
      this._text_171,
      this._text_172,
      this._text_173,
      this._text_174,
      this._text_175
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6,
      disposable_7,
      disposable_8,
      disposable_9,
      disposable_10
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import18.NgClass) && ((26 <= requestNodeIndex) && (requestNodeIndex <= 72)))) { return this._NgClass_26_3.context; }
    if (((token === import19.MaskedInputDirective) && (102 === requestNodeIndex))) { return this._MaskedInputDirective_102_3.context; }
    if (((token === import20.NG_VALUE_ACCESSOR) && (102 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_102_4; }
    if (((token === import19.MaskedInputDirective) && (129 === requestNodeIndex))) { return this._MaskedInputDirective_129_3.context; }
    if (((token === import20.NG_VALUE_ACCESSOR) && (129 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_129_4; }
    if (((token === import19.MaskedInputDirective) && (140 === requestNodeIndex))) { return this._MaskedInputDirective_140_3.context; }
    if (((token === import20.NG_VALUE_ACCESSOR) && (140 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_140_4; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_26_0_0:any = 'eva-3-nps ';
    this._NgClass_26_3.check_klass(currVal_26_0_0,throwOnChange,false);
    const currVal_26_0_1:any = this.context.getClassTerminalSelected();
    this._NgClass_26_3.check_ngClass(currVal_26_0_1,throwOnChange,false);
    this._NgClass_26_3.ngDoCheck(this,this._el_26,throwOnChange);
    const currVal_102_0_0:any = this._map_201(this.context.mask,true,false);
    this._MaskedInputDirective_102_3.check_textMaskConfig(currVal_102_0_0,throwOnChange,false);
    this._MaskedInputDirective_102_3.ngDoCheck(this,this._el_102,throwOnChange);
    const currVal_129_0_0:any = this._map_204(this.context.mask,true,false);
    this._MaskedInputDirective_129_3.check_textMaskConfig(currVal_129_0_0,throwOnChange,false);
    this._MaskedInputDirective_129_3.ngDoCheck(this,this._el_129,throwOnChange);
    const currVal_140_0_0:any = this._map_207(this.context.mask,true,false);
    this._MaskedInputDirective_140_3.check_textMaskConfig(currVal_140_0_0,throwOnChange,false);
    this._MaskedInputDirective_140_3.ngDoCheck(this,this._el_140,throwOnChange);
    valUnwrapper.reset();
    const currVal_183:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pickupPoint.sited_in_airport.modal.title')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_183,currVal_183))) {
      this.renderer.setText(this._text_9,currVal_183);
      this._expr_183 = currVal_183;
    }
    valUnwrapper.reset();
    const currVal_185:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('pickupPoint.sited_in_airport.modal.subtitle')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_185,currVal_185))) {
      this.renderer.setText(this._text_15,currVal_185);
      this._expr_185 = currVal_185;
    }
    valUnwrapper.reset();
    const currVal_187:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('pickupPoint.agent_in_terminal.terminal.title')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_187,currVal_187))) {
      this.renderer.setText(this._text_24,currVal_187);
      this._expr_187 = currVal_187;
    }
    valUnwrapper.reset();
    const currVal_189:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('pickupPoint.agent_in_terminal.terminal.terminal_a')),'\n                                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_189,currVal_189))) {
      this.renderer.setText(this._text_36,currVal_189);
      this._expr_189 = currVal_189;
    }
    valUnwrapper.reset();
    const currVal_191:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('pickupPoint.agent_in_terminal.terminal.terminal_a.tooltip')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_191,currVal_191))) {
      this.renderer.setText(this._text_43,currVal_191);
      this._expr_191 = currVal_191;
    }
    valUnwrapper.reset();
    const currVal_193:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('pickupPoint.agent_in_terminal.terminal.terminal_b')),'\n                                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_193,currVal_193))) {
      this.renderer.setText(this._text_49,currVal_193);
      this._expr_193 = currVal_193;
    }
    valUnwrapper.reset();
    const currVal_195:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('pickupPoint.agent_in_terminal.terminal.terminal_b.tooltip')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_195,currVal_195))) {
      this.renderer.setText(this._text_56,currVal_195);
      this._expr_195 = currVal_195;
    }
    const currVal_197:any = import3.inlineInterpolate(1,'',this.context.getTerminalSelected(),'');
    if (import3.checkBinding(throwOnChange,this._expr_197,currVal_197)) {
      this.renderer.setElementProperty(this._el_68,'value',currVal_197);
      this._expr_197 = currVal_197;
    }
    const currVal_198:any = this.context.errorInStop;
    if (import3.checkBinding(throwOnChange,this._expr_198,currVal_198)) {
      this.renderer.setElementClass(this._el_78,'invalid-field',currVal_198);
      this._expr_198 = currVal_198;
    }
    valUnwrapper.reset();
    const currVal_199:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('pickupPoint.agent_in_terminal.stop.option_a')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_199,currVal_199))) {
      this.renderer.setText(this._text_94,currVal_199);
      this._expr_199 = currVal_199;
    }
    valUnwrapper.reset();
    const currVal_202:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('pickupPoint.agent_in_terminal.stop.option_b')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_202,currVal_202))) {
      this.renderer.setText(this._text_121,currVal_202);
      this._expr_202 = currVal_202;
    }
    valUnwrapper.reset();
    const currVal_205:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_9.transform('pickupPoint.agent_in_terminal.stop.text_until')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_205,currVal_205))) {
      this.renderer.setText(this._text_134,currVal_205);
      this._expr_205 = currVal_205;
    }
    const currVal_208:boolean = !this.context.errorInStop;
    if (import3.checkBinding(throwOnChange,this._expr_208,currVal_208)) {
      this.renderer.setElementProperty(this._el_148,'hidden',currVal_208);
      this._expr_208 = currVal_208;
    }
    const currVal_209:boolean = !this.context.errorInStop;
    if (import3.checkBinding(throwOnChange,this._expr_209,currVal_209)) {
      this.renderer.setElementProperty(this._el_150,'hidden',currVal_209);
      this._expr_209 = currVal_209;
    }
    valUnwrapper.reset();
    const currVal_210:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_10.transform(this.context.errorTextInStop)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_210,currVal_210))) {
      this.renderer.setText(this._text_151,currVal_210);
      this._expr_210 = currVal_210;
    }
    const currVal_212:any = this.context.isAddMeetingPointDisabled();
    if (import3.checkBinding(throwOnChange,this._expr_212,currVal_212)) {
      this.renderer.setElementProperty(this._el_160,'disabled',currVal_212);
      this._expr_212 = currVal_212;
    }
    valUnwrapper.reset();
    const currVal_213:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_11.transform('common.SAVE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_213,currVal_213))) {
      this.renderer.setText(this._text_163,currVal_213);
      this._expr_213 = currVal_213;
    }
    valUnwrapper.reset();
    const currVal_215:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_12.transform('common.CANCEL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_215,currVal_215))) {
      this.renderer.setText(this._text_170,currVal_215);
      this._expr_215 = currVal_215;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
    this._pipe_translate_12.ngOnDestroy();
  }
  handleEvent_11(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.showModalNewDeliveryPoint(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_35(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.selectTerminal(0,true)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_48(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.selectTerminal(1,true)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_86(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.selectSingleStop()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_102(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._MaskedInputDirective_102_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'focusout')) {
      const pd_sub_0:any = ((<any>this.context.focusOutSingleStop()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_113(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.selectRangeStop()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_129(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._MaskedInputDirective_129_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'focusout')) {
      const pd_sub_0:any = ((<any>this.context.focusOutRangeStopFrom()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_140(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._MaskedInputDirective_140_3.handleEvent(eventName,$event) && result);
    if ((eventName == 'focusout')) {
      const pd_sub_0:any = ((<any>this.context.focusOutRangeStopTo()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_158(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.gaNotify()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_160(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.addNewMeetingPoint()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_167(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.showModalNewDeliveryPoint(false)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pointOfSale/delivery-instructions/orlando-instructions/orlando-modal-new-delivery-point.component.ngfactory.ts